import { render, staticRenderFns } from "./ItemSquare.vue?vue&type=template&id=3a24db36&scoped=true&"
import script from "./ItemSquare.vue?vue&type=script&lang=js&"
export * from "./ItemSquare.vue?vue&type=script&lang=js&"
import style0 from "./ItemSquare.vue?vue&type=style&index=0&id=3a24db36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24db36",
  null
  
)

export default component.exports